import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { Flex } from '@afterpaytouch/core'
import { useFlag } from '@afterpaytouch/feature'
import { BASE_PATH } from '../../../../env'
import { Features } from '../../../../model'
import styles from './style.module.css'

export enum RetailNuxUpdateVariant {
  APPLE_PRODUCTS = 'A',
  CONTROL = 'C',
}

const heroImages = {
  appleProducts: { path: 'images/apple-retail-nux-hero.png', alt: 'Apple products', width: 400, height: 380, className: styles.container },
  calendar: { path: 'images/apple-retail-nux-hero.svg', alt: 'Afterpay calendar', width: 400, height: 400, className: undefined },
}

export const HeroImage: FunctionComponent = () => {
  const variant = useFlag<string>(Features.RETAIL_NUX_UPDATE, RetailNuxUpdateVariant.CONTROL)
  const heroImage = variant === RetailNuxUpdateVariant.APPLE_PRODUCTS ? heroImages.appleProducts : heroImages.calendar
  const imageSrc = [BASE_PATH, heroImage.path].join('/')

  return (
    <Flex alignItems='center' justifyContent='center' className={heroImage.className}>
      <Image loading='eager' src={imageSrc} alt={heroImage.alt} width={heroImage.width} height={heroImage.height} />
    </Flex>
  )
}
